module.exports = __webpack_public_path__ + "img/symbol_12.3f3d2e9b.png";